export default __webpack_public_path__ + "static/media/4.f4763a10.png";